export class CommonNextDayScheduleRequest {
  lstId: CommonNextDayScheduleId[];
  dtDate: Date;
}

export class CommonNextDayScheduleId {
  intId: number;
}
